{
  "tags": {
    "tag": "Tag",
    "used": "Used",
    "created_at": "Created at",
    "actions": "Actions",
    "contacts": "Contacts",
    "companies": "Companies",
    "rename_tag": "rename tag",
    "order_by": "Order by",
    "delete_tag_confirm_title": "Are you sure you want to delete this tag?",
    "delete_tags_confirm_title": "Are you sure you want to delete those tags?",
    "remove_tag": "remove tag",
    "delete_tags": "Delete Tags",
    "bulk_remove_tag": "bulk remove tag",
    "tags_label": "Tags",
    "type_to_search": "Type to search tags",
    "tags_placeholder": "Tags",
    "tag_name_label": "Tag Name *",
    "name_tag_placeholder": "Name the tag",
    "name_required": "Please enter a name",
    "tag_created": "Tag created.",
    "tag_update_notice": "It might take up to 30 minutes to update the tag on all contacts and companies.",
    "tag_removal_notice": "It might take up to 30 minutes for the tag to be removed from all the companies and contacts.",
    "tags_removal_notice": "It might take up to 30 minutes for the tags to be removed from all the companies and contacts."
  }
}
